import { Alert, DatePicker, Form, Modal } from 'antd';
import type { Dayjs } from 'dayjs';

interface FirstPeriodModalProps {
  open: boolean;
  startDay: number | null;
  error: string | null;
  submitting: boolean;
  onCreate: (startDate: string) => Promise<boolean>;
  onClose: () => void;
}

/** With no period yet there is nothing to follow, so the first one is placed by hand, on the day the period rule starts months. */
export function FirstPeriodModal({ open, startDay, error, submitting, onCreate, onClose }: FirstPeriodModalProps) {
  const [form] = Form.useForm<{ startDate: Dayjs }>();

  async function submit(values: { startDate: Dayjs }) {
    if (await onCreate(values.startDate.format('YYYY-MM-DD'))) {
      form.resetFields();
      onClose();
    }
  }

  return (
    <Modal
      open={open}
      title="Add the first period"
      okText="Add period"
      confirmLoading={submitting}
      onOk={() => form.submit()}
      onCancel={onClose}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" onFinish={submit}>
        <p className="mb-4 text-sm text-muted">
          There are no periods yet. Pick where the first one starts; later periods follow on from it
          {startDay !== null && `, and it has to start on day ${startDay} of a month, the period rule's start day`}.
        </p>
        {error && <Alert type="error" showIcon message={error} className="mb-4" />}
        <Form.Item name="startDate" label="Starts on" rules={[{ required: true, message: 'Pick the day the first period starts' }]}>
          <DatePicker className="w-full" disabledDate={(day) => startDay !== null && day.date() !== startDay} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
